module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"et":{"Country":"Riik","Load more countries":"Lae rohkem riike"}}')
  delete Component.options._Ctor
}
